<template>
  <div class="root">
    <component class="headline zero-mp" :is="blok.tag" :style="styleMap" :data-size="blok.tag" :data-inspect="blok.tag">
      {{ blok.text }}
    </component>
  </div>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  mixins: [cms],
  name: "cms-headline",
  computed: {
    styleMap() {
      const map = { "xs": 300, "sm": 400, "md": 500, "lg": 600, "xl": 700, "xxl": 800, "xxxl": 900 };
      return {
        "--size": `var(--fs-${map[this.blok.size]})`,
        "--color": `var(--crf-${this.blok.color}, --crf-flip)`,
      }
    },
  }
}
</script>

<style scoped>
.headline {
  font-size: var(--size, clamp(1.62rem, calc(1.37rem + 1.24vw), 2.33rem));
  font-weight: 700;
  font-family: var(--crf-ff-head);
  line-height: 1.3;
  user-select: none;
  word-wrap: break-word;
  color: var(--color);
}
</style>
